const routes = {
  base: '/',
  membership: '/membership',
  contactBilling: '/contact-billing',
  shippingOptions: '/shipping-options',
  storePickup: '/store-pickup',
  orderSummary: '/order-summary..', // The .. is necessary to match the URL with PayPal query params added
  orderConfirmation: '/order-confirmation..',
}

export default routes
